import React from "react";

import styles from "./ImageButton.module.css";


interface ImageButtonProps {
    disabled?: boolean
    onClick: () => any
    children: React.ReactNode;
}

export const ImageButton: React.FC<ImageButtonProps> = ({
                                                            disabled,
                                                            onClick,
                                                            children
                                                        }) => {
    return <div
        className={`${styles.wrapper} ${disabled && styles.wrapperDisabled}`}
        onClick={() => !disabled && onClick()}
        aria-disabled={disabled}>
        <div className={`${styles.icon} ${disabled && styles.iconDisabled}`}>
            {children}
        </div>
    </div>
}
